import { type ErrorContexts, type WithContext } from '@lingoda/errors';

interface Options {
    context: ErrorContexts;
    serverHour: string;
}

export class BrowserTimeSyncError extends Error implements WithContext {
    public readonly context?: ErrorContexts;
    // UTC hour of the server time, "YYYY-MM-DDTHH".
    // Used to limit how many times one browser reports this error to Sentry per hour.
    public readonly serverHour: string;

    constructor(message: string, options: Options) {
        const { context, serverHour } = options;
        super(message);
        this.name = 'BrowserTimeSyncError';
        this.context = context;
        this.serverHour = serverHour;
    }
}
